import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { LucideIcon } from 'lucide-react';

interface ReportItem {
  label: string;
  description?: string;
}

interface ReportCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  items: ReportItem[];
  value: string;
  customContent?: React.ReactNode;
}

export default function ReportCard({ 
  icon: Icon, 
  title, 
  description, 
  items, 
  value,
  customContent 
}: ReportCardProps) {
  return (
    <Card className="border-luxury-silver-light/40">
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="report" className="border-none">
          <AccordionTrigger className="hover:no-underline px-6 pt-6">
            <CardHeader className="p-0 w-full">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-brand-primary rounded-lg">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1 text-left">
                  <CardTitle className="text-xl text-brand-primary">{title}</CardTitle>
                  <CardDescription className="text-brand-dark">{description}</CardDescription>
                </div>
              </div>
            </CardHeader>
          </AccordionTrigger>
          <AccordionContent>
            <CardContent className="px-6 pb-6 pt-4">
              {customContent ? (
                customContent
              ) : (
                <div className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {items.map((item, index) => (
                      <div 
                        key={index} 
                        className="p-4 bg-luxury-silver-light/30 rounded-lg hover:bg-luxury-silver-light/50 transition-colors"
                      >
                        <p className="text-sm font-medium text-brand-dark">{item.label}</p>
                        {item.description && (
                          <p className="text-xs text-brand-dark mt-1">{item.description}</p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </CardContent>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </Card>
  );
}

